import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import whiteLogo from '../../assets/svgs/logo-white.svg';
import iconSprite from '../../assets/icon-sprite.svg';

class SideNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { page, user, business } = this.props;
    console.log("Users details",business)
    console.log("Users details original",user.id)
    return (
      <nav className="sidebar bg-secondary d-none d-lg-block flex-column overflow-auto">
        <header className="sidebar__header">
          <div className="sidebar__header--container">
            <img src={whiteLogo} height="30" alt="P2Vest Logo" />
          </div>
          {/* <span className="text-white">
            Org ID:
            {business.id}
          </span> */}
        </header>
        <main className="sidebar__main">
          <ul className="nav flex-column">
            <li className="nav-item" hidden={business.status !== 'active'}>
              <Link className={page === 'dashboard' ? 'nav-link active-page' : 'nav-link'} to="/dashboard">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#dashboard'}></use>
                </svg>
                Home
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'analysis' ? 'nav-link active-page' : 'nav-link'} to="/analysis">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#analysis'}></use>
                </svg>
                Analysis
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'calculator' ? 'nav-link active-page' : 'nav-link'} to="/calculator">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#calculator'}></use>
                </svg>
                Calculator
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'users' ? 'nav-link active-page' : 'nav-link'} to="/users">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#customers'}></use>
                </svg>
                Users
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'agents' ? 'nav-link active-page' : 'nav-link'} to="/agents">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#agents'}></use>
                </svg>
                Agents
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type == 'business' || user.type == 'initiator'}>
              <Link className={page === 'validations' ? 'nav-link active-page' : 'nav-link'} to="/validations">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#validations'}></use>
                </svg>
                Validations
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || (user.type !== 'business' && user.type !== 'initiator')}>
              <Link className={page === 'loans' ? 'nav-link active-page' : 'nav-link'} to="/loans">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#loans'}></use>
                </svg>
                Loans
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'loan-requests' ? 'nav-link active-page' : 'nav-link'} to="/loan-requests">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#loanrequest'}></use>
                </svg>
                Loan Requests
              </Link>
            </li>

            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business' || user.id !==1030096}>
              <Link className={page === 'credit-line' ? 'nav-link active-page' : 'nav-link'} to="/credit-line">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#loanrequest'}></use>
                </svg>
                Credit Line
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'transactions' ? 'nav-link active-page' : 'nav-link'} to="/transactions">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#menu'}></use>
                </svg>
                Transactions
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'payments' ? 'nav-link active-page' : 'nav-link'} to="/payments">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#payments'}></use>
                </svg>
                Payments
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'business'}>
              <Link className={page === 'reports' ? 'nav-link active-page' : 'nav-link'} to="/reports">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#report'}></use>
                </svg>
                Loan Report
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'broker'}>
              <Link className={page === 'insurance' ? 'nav-link active-page' : 'nav-link'} to="/insurance">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#report'}></use>
                </svg>
                Insurance
              </Link>
            </li>
            <li className="nav-item" hidden={business.status !== 'active' || user.type !== 'broker'}>
              <Link className={page === 'commissions' ? 'nav-link active-page' : 'nav-link'} to="/commissions">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#report'}></use>
                </svg>
                Commissions
              </Link>
            </li>
            {/* <li className="nav-item" hidden={business.status !== 'active'}>
              <Link className={page === 'agentperformance' ? 'nav-link active-page' : 'nav-link'} to="/agent-performance">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#menu'}></use>
                </svg>
                Performance
              </Link>
            </li> */}
            <li className="nav-item" hidden={business.status !== 'active'}>
              <Link className={page === 'settings' ? 'nav-link active-page' : 'nav-link'} to="/settings">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#settings'}></use>
                </svg>
                Settings
              </Link>
            </li>
          </ul>
        </main>
        <footer className="sidebar__footer">
          <ul className="nav flex-column">
            <li className="nav-item">
              <Link className="nav-link" to="/login">
                <svg width="20" height="20">
                  <use xlinkHref={iconSprite + '#logout'}></use>
                </svg>
                Logout
              </Link>
            </li>
          </ul>
        </footer>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  business: state.account?.business || {},
  user: state.account?.user || {}
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SideNav);
